<template>
  <v-menu v-model="menu" offset-y :close-on-content-click="false">
    <template v-slot:activator="{ on, attrs, value }">
      <FilterTriggerBtn
        class="ml-8 py-3"
        :attrs="attrs"
        :on="on"
        :isActive="value"
      />
    </template>

    <div class="py-3 filter-container">
      <div class="d-flex justify-space-between align-center px-5 mb-2">
        <div class="filter-titile">
          기간 필터
        </div>
        <button type="button" class="filter-btn" @click="onFilterBtn">
          적용
        </button>
      </div>

      <FilterYearMonthPanel
        ref="filterPanelRef"
        :yearList="yearList"
        :activeMonths="activeMonths"
        :isDisabled="true"
        @onSelectYearMonth="onSelectYearMonth"
      />
    </div>
  </v-menu>
</template>

<script>
import FilterYearMonthPanel from "@/components/filter/FilterYearMonthPanel.vue";
import FilterTriggerBtn from "@/components/filter/FilterTriggerBtn.vue";

export default {
  /** emits : onUpdateFilter{ yearCheckList, checkedMonths }) */
  props: {
    yearList: { type: Array, default: () => {} },
    activeMonths: { type: Array, default: () => {} },
  },
  components: { FilterYearMonthPanel, FilterTriggerBtn },
  data: () => ({
    menu: false,
    yearCheckList: [],
    checkedMonths: [],
    isSubmited: false,
  }),
  watch: {
    menu(newVal) {
      if (newVal) {
        // if (!this.isSubmited) {
        //   this.$nextTick(() => {
        //     this.$refs?.filterPanelRef.initFilter();
        //   });
        // }
      }
    },
  },
  methods: {
    onSelectYearMonth({ yearCheckList, checkedMonths }) {
      this.yearCheckList = yearCheckList;
      this.checkedMonths = checkedMonths;
      // this.isSubmited = false;
    },
    onFilterBtn() {
      this.$emit("onUpdateFilter", {
        yearCheckList: this.yearCheckList,
        monthCheckList: this.checkedMonths,
      });
      // this.isSubmited = true;
      this.menu = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-container {
  width: 272px;
  max-height: 318px;
  background-color: white;
}
.filter-titile {
  color: #666666;
  font-size: 14px;
  font-weight: 500;
}
.filter-btn {
  border-radius: 5px;
  background: #666666;
  color: white;
  padding: 4px 12px;
  font-size: 14px;
  &:hover {
    background: #797979;
    transition: 0.1s ease-in-out;
  }
}
</style>
